<div>
    <div *ngIf="msg"><span class="alert alert-danger">{{msg}}</span></div>
    <div class="form-group row">
        <div class="col-6">
            <input list="browsers" type="text" class="form-control" name="browser" [(ngModel)]="newTag">
            <datalist id="browsers">
                <option *ngFor="let tag of tagList">{{tag}}</option>
            </datalist>
        </div>
        <div class="col-4">
            <button class="p-button p-button-sm p-button-primary" (click)="addTag()" >Add</button>
        </div>
    </div>
    <div class="row">
        <span *ngFor="let tag of tags" class="tag label label-primary">{{tag}} <small class="oi oi-delete" title="remove" (click)="deleteTag(tag)"></small></span>
    </div>

    <button class="p-button p-button-sm p-button-primary" (click)="updateTags()">Update</button>
</div>
